import { render, staticRenderFns } from "./ManageVideo.vue?vue&type=template&id=c0f6a3be&scoped=true"
import script from "./ManageVideo.vue?vue&type=script&lang=js"
export * from "./ManageVideo.vue?vue&type=script&lang=js"
import style0 from "./ManageVideo.vue?vue&type=style&index=0&id=c0f6a3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f6a3be",
  null
  
)

export default component.exports